import React from 'react';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
import { TrustBadges } from './TrustBadges';
export function Hero() {
  return <section className="pt-4 pb-4 px-4 sm:px-6 bg-white text-center" data-id="element-70" data-mp="ei1vfm5pk2xy">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-pink text-brand-violet font-bold text-[10px] sm:text-[11px] mb-2 tracking-wide uppercase" data-id="element-71" data-mp="9lbkfd8rfxje">
        ✦ Le Système Complet 6-en-1 pour Professeurs
      </div>
      <h1 className="font-display text-[26px] leading-[0.95] sm:text-5xl tracking-wide text-brand-violet mb-2 uppercase" data-id="element-72" data-mp="xanojyp8dfeu">
        Le Système Complet de Planification pour les Professeurs de Gymnastique Rythmique
      </h1>
      <p className="text-[13px] sm:text-base text-brand-slate font-semibold leading-snug mb-3 max-w-2xl mx-auto" data-id="element-73" data-mp="nczrh245jvti">
        Gagnez des heures de préparation chaque semaine grâce à un système professionnel conçu pour construire vos
        séances, organiser votre saison, planifier la progression de vos gymnastes et préparer vos entraînements avec
        davantage d&apos;efficacité — sans repartir de zéro avant chaque cours.
      </p>
      <div className="mb-3" data-id="element-74" data-mp="3o6u71a6kmrcx">
        <ProductImage className="max-w-[280px] sm:max-w-sm" data-id="element-75" data-mp="39acwuma4biry" />
      </div>
      <div className="max-w-md mx-auto mb-2" data-id="element-76" data-mp="39cflb1vmh3uk">
        <CTAButton data-id="element-77" data-mp="3e8wi0kgw0qj9">🚀 OUI ! JE VEUX MON SYSTÈME MAINTENANT</CTAButton>
      </div>
      <TrustBadges data-id="element-78" data-mp="30iazwxz9ckmf" />
    </section>;
}